import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const SalaryStructure = () => {
  return <ErpTablePage moduleKey="hrm_salary_structure" />;
};

export default SalaryStructure;
